var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: "#366695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.545 22.9995C17.5658 22.9763 22.4952 18.3269 22.9633 12.4211L15.7334 5.19128L13.2143 9.53658H4.69802V12.3002L8.80339 16.4056L6.60536 16.9305L7.97822 18.3034L7.18755 18.4255L11.545 22.9995Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2761 12.3002C18.1264 12.3002 18.005 12.1788 18.005 12.0291V9.6156H16.1594C16.0097 9.6156 15.8883 9.49427 15.8883 9.34455C15.8883 9.19482 16.0097 9.07349 16.1594 9.07349H18.2761C18.4258 9.07349 18.5472 9.19482 18.5472 9.34455V12.0291C18.5471 12.1788 18.4258 12.3002 18.2761 12.3002Z",
    fill: "#121149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69802 12.3002C4.54834 12.3002 4.42696 12.1788 4.42696 12.0291V9.34455C4.42696 9.19487 4.5483 9.07349 4.69802 9.07349H6.81474C6.96442 9.07349 7.0858 9.19482 7.0858 9.34455C7.0858 9.49427 6.96447 9.6156 6.81474 9.6156H4.96908V12.0291C4.96908 12.1788 4.84775 12.3002 4.69802 12.3002Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3419 18.5402H14.2109C13.9947 18.5402 13.8193 18.3648 13.8193 18.1486V16.0604C13.8193 15.8442 13.9947 15.6689 14.2109 15.6689H15.3419C15.5582 15.6689 15.7335 15.8442 15.7335 16.0604V18.1486C15.7335 18.3649 15.5582 18.5402 15.3419 18.5402Z",
    fill: "#272525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59558 18.5402H7.46449C7.24828 18.5402 7.07295 18.3648 7.07295 18.1486V16.0604C7.07295 15.8442 7.24828 15.6689 7.46449 15.6689H8.59558C8.81179 15.6689 8.98712 15.8442 8.98712 16.0604V18.1486C8.98712 18.3649 8.81179 18.5402 8.59558 18.5402Z",
    fill: "#272525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06648 17.108H15.9077C16.2891 17.108 16.5983 16.7989 16.5983 16.4175V6.74387C16.5983 5.73519 15.7806 4.91748 14.772 4.91748H8.20242C7.19374 4.91748 6.37603 5.73519 6.37603 6.74387V16.4175C6.37594 16.7988 6.68509 17.108 7.06648 17.108Z",
    fill: "#C92F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7719 4.91748H11.5V17.108H15.9077C16.2891 17.108 16.5983 16.7989 16.5983 16.4175V6.74378C16.5982 5.73519 15.7805 4.91748 14.7719 4.91748Z",
    fill: "#930000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9009 6.19525H7.07268V10.0286H15.9009V6.19525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9012 6.19525H11.5V10.0286H15.9012V6.19525Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0964 10.6481H7.07268V14.5847H11.0964V10.6481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9008 10.6481H11.8771V14.5847H15.9008V10.6481Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79601 16.2107C8.09539 16.2107 8.33808 15.968 8.33808 15.6687C8.33808 15.3693 8.09539 15.1266 7.79601 15.1266C7.49663 15.1266 7.25394 15.3693 7.25394 15.6687C7.25394 15.968 7.49663 16.2107 7.79601 16.2107Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998 16.2107C15.2974 16.2107 15.5401 15.968 15.5401 15.6687C15.5401 15.3693 15.2974 15.1266 14.998 15.1266C14.6986 15.1266 14.4559 15.3693 14.4559 15.6687C14.4559 15.968 14.6986 16.2107 14.998 16.2107Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1908 15.8754H9.39617C9.35336 15.8754 9.31873 15.8408 9.31873 15.798C9.31873 15.7552 9.35336 15.7205 9.39617 15.7205H13.1908C13.2336 15.7205 13.2682 15.7552 13.2682 15.798C13.2682 15.8408 13.2336 15.8754 13.1908 15.8754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1908 15.7205H11.5V15.8754H13.1908C13.2336 15.8754 13.2682 15.8408 13.2682 15.798C13.2682 15.7552 13.2336 15.7205 13.1908 15.7205Z",
    fill: "#D0D1D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinline);
export default __webpack_public_path__ + "static/media/bus.inline.5ab8e77c3be3be0c12db28242aaa8e73.svg";
export { ForwardRef as ReactComponent };